/**
 * Resolver de deep links internos de la app
 * Sprint 10 - Push Notifications
 */

const FALLBACK_ROUTE = '/';

const ALLOWED_PREFIXES = [
    '/',
    '/admin',
    '/chat',
    '/driver',
    '/marketplace',
    '/operator',
    '/settings',
    '/device-unbind',
    '/verify-account',
    '/forgot-password',
    '/reset-password',
    '/login',
    '/register',
];

function normalizeRawPath(rawDeepLink?: string): string {
    if (!rawDeepLink || rawDeepLink.trim() === '') {
        return FALLBACK_ROUTE;
    }

    const trimmed = rawDeepLink.trim();

    // Soporte básico para links con esquema (ej. marketplace://home o https://...).
    if (trimmed.includes('://')) {
        try {
            const url = new URL(trimmed);
            const isHttp = url.protocol === 'http:' || url.protocol === 'https:';
            const hostPath = isHttp || url.host.trim() === '' ? '' : `/${url.host}`;
            const composedPath = `${hostPath}${url.pathname}`.replace(/\/{2,}/g, '/');

            return `${composedPath}${url.search}${url.hash}` || FALLBACK_ROUTE;
        } catch {
            return FALLBACK_ROUTE;
        }
    }

    return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}

export function resolveDeepLink(rawDeepLink?: string): string {
    const normalized = normalizeRawPath(rawDeepLink)
        .replace(/^\/contracts(?=\/|$)/, '/marketplace/contracts')
        .replace(/^\/operator\/provider-payouts(?=\/|$)/, '/operator/payouts')
        .replace(/^\/operator\/bank-accounts(?=\/|$)/, '/marketplace/operator/onboarding?section=bancos');

    // Compatibilidad con payload base del sprint.
    if (normalized === '/home') {
        return '/';
    }

    const isAllowed = ALLOWED_PREFIXES.some((prefix) => {
        if (prefix === '/') {
            return normalized === '/';
        }

        return normalized === prefix || normalized.startsWith(`${prefix}/`);
    });

    return isAllowed ? normalized : FALLBACK_ROUTE;
}
